import { useT } from '../i18n/I18nProvider';

/**
 * The Takove lockup: the symbol (decorative, `.brand-symbol` in styles.css,
 * drawn in the primary token) beside the name as real text, so whatever
 * wraps it (a home link, the footer) is named by the visible text. Symbol
 * adopted from prototype@c0c19a1 (`public/brand/takove-symbol.svg`).
 */
export function BrandLogo() {
  const { t } = useT();

  return (
    <span className="inline-flex items-center gap-2 text-lg font-semibold uppercase tracking-[0.2em] text-base-content">
      <span aria-hidden="true" className="brand-symbol h-8 w-8 shrink-0 bg-primary" />
      {t('app.brand:name')}
    </span>
  );
}
